//import defAvatar from '@/assets/default_avatar.png'

export default {
  auth_request : (state) => {
    state.status = 'loading'
  },
  auth_success : (state, payload) => {

    //if (!payload.usuario.avatar) payload.usuario.avatar = defAvatar

    localStorage.setItem('usuario', JSON.stringify(payload.usuario))
    localStorage.setItem('token', payload.token)
    localStorage.setItem('expira', payload.expira)
    localStorage.setItem('menus', payload.menus)

    state.status = 'success'
    state.token = payload.token
    state.tempo = payload.expira
    state.user = payload.usuario
    state.menus = Object.assign({}, JSON.parse(payload.menus))
    localStorage.setItem('expira', state.tempo)
  },
  auth_refresh_token : (state, payload) => {
    state.token = payload.token
    state.tempo = payload.expira
    localStorage.setItem('token', payload.token)
    localStorage.setItem('expira', payload.expira)
  },
  auth_error : (state, err) => {
    state.status = 'error'
  },
  auth_logout : (state) => {
    return new Promise((resolve, reject) => {
      state.status = ''
      state.token = ''
      state.user = {}
      localStorage.clear()
      resolve()
    })
  },
  reset_login : (state) => {
    state.status = ''
    state.token = ''
    state.user = {}
    state.menus = []
    localStorage.clear()
  },
  config_menu : (state, menu) => {
    state.menus = menu
  },
  atualizaAvatar : (state, avatar) => {
    //if (!avatar) avatar = defAvatar
    
    //atualiza vuex user
    let user = state.user
    if (user) user.avatar = avatar
    state.user = user

    //atualiza localStorage(usuario)
    let usuarioAvatar = JSON.parse(localStorage.getItem('usuario'))
    if (usuarioAvatar) {
      //usuarioAvatar.avatar = defAvatar
      localStorage.setItem('usuario', JSON.stringify(usuarioAvatar))
    }
  },
  contador : (state, { tempo, tempoform}) => {
    state.cronometro = tempoform
    state.tempo = tempo
    localStorage.setItem('expira', tempo)
  }
}


// WEBPACK FOOTER //
// ./src/views/Login/_store/mutations.js